import { enumToString, STANDARD_FREIGHT_MODES } from 'clerk_common/enums';

export const getFreightModeOptions = () => {
  return [...STANDARD_FREIGHT_MODES].map((type) => ({
    id: type,
    label: enumToString(type),
  }));
};
